<template>
  <div id="webmoFormWrapper" class="uk-container uk-container-xsmall">
    <form id="registration" encytype="multipart/form-data" name="registration" class="uk-form-horizontal uk-margin-large" v-on:submit.prevent="handleSubmit($event)">
      <fieldset class="uk-fieldset">
          <div class="uk-margin">
            <label class="uk-form-label" for="">Webmo type</label>
            <div class="uk-form-controls uk-grid-small uk-child-width-auto uk-grid">
              <template v-for="type in types">
                <label v-bind:key="type"><input type="radio" v-bind:key="type" v-bind:value="type" v-model.trim="$v.form.type.$model" :class="{ 'uk-form-danger': $v.form.type.$error }" name="type" class="uk-radio" v-bind:id="'type-' + type">{{ getType(type) }}</label>
              </template>
            </div>
            <div class="uk-form-messages">
              <div class="uk-form-controls uk-form-danger" v-if="!$v.form.type.required && $v.form.type.$dirty">This field is required</div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">Language</label>
            <div class="uk-form-controls uk-grid-small uk-child-width-auto uk-grid">
              <template v-for="lang in languages">
                <label v-bind:key="lang">
                  <input type="radio" v-bind:id="'language-' + lang" v-bind:key="lang" v-bind:value="lang" v-model.trim="$v.form.language.$model" :class="{ 'uk-form-danger': $v.form.language.$error }" name="language" class="uk-radio">
                  {{ getLang(lang) }}
                </label>
              </template>
            </div>
            <div class="uk-form-messages">
              <div class="uk-form-controls uk-form-danger" v-if="!$v.form.language.required && $v.form.language.$dirty">This field is required</div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">Domain</label>
            <div class="uk-form-controls">
              <input v-model.trim="$v.form.domain.$model" @blur="showNoteOnError()" @input="toLower($v.form.domain);delayTouch($v.form.domain)" :class="{ 'uk-form-danger': !this.domainValidationNetworkError && $v.form.domain.$invalid && $v.form.domain.$dirty, 'uk-form-success': !$v.form.domain.$invalid && $v.form.domain.$dirty }" name="domain" class="uk-input uk-form-small uk-width-1-2" id="domain" type="text" placeholder="myproject">
              <span :class="{ 'uk-form-danger': $v.form.domain.$error, 'uk-form-success': !$v.form.domain.$invalid && $v.form.domain.$dirty }">.webmo.online</span>
              <div v-if="!domainValidationNetworkError" class="uk-form-messages">
                <div class="uk-form-danger" v-if="!$v.form.domain.required && $v.form.domain.$dirty">This field is required</div>
                <div class="uk-form-danger" v-if="$v.form.domain.required && !$v.form.domain.validDomain && $v.form.domain.$dirty">This is not a valid domain</div>
                <div class="uk-form-danger" v-if="$v.form.domain.required && !$v.form.domain.isUniqueDomain && $v.form.domain.$dirty">This domain is already taken</div>
                <div class="uk-form-success" v-if="!$v.form.domain.$invalid && $v.form.domain.$dirty">The domain <strong>https://{{form.domain}}.webmo.online</strong> is available!</div>
              </div>
            </div>
          </div>

          <div v-if="form.logo.url" class="uk-container uk-padding-large">
            <div uk-grid>
              <div class="uk-width-auto">
                <div class="logo-preview-login">
                  <p>Logo preview for the WebMo login screen.</p>
                  <img v-bind:src="form.logo.url" v-bind:alt="form.logo.name"/>
                </div>
              </div>
              <div class="uk-width-auto">
                <div class="logo-preview-sidebar">
                  <p>Logo preview for the WebMo.</p>
                  <img v-bind:src="form.logo.url" v-bind:alt="form.logo.name"/>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">First name</label>
            <div class="uk-form-controls">
                <input v-model.trim="$v.form.firstname.$model" :class="{ 'uk-form-danger': $v.form.firstname.$error }" name="firstname" class="uk-input" id="firstname" type="text">
                <div class="uk-form-messages">
                  <div class="uk-form-danger" v-if="!$v.form.firstname.required && $v.form.firstname.$dirty">This field is required</div>
                </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">Last name</label>
            <div class="uk-form-controls">
                <input v-model.trim="$v.form.lastname.$model" :class="{ 'uk-form-danger': $v.form.lastname.$error }" name="lastname" class="uk-input" id="lastname" type="text">
                <div class="uk-form-messages">
                  <div class="uk-form-danger" v-if="!$v.form.lastname.required && $v.form.lastname.$dirty">This field is required</div>
                </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">
              <span uk-tooltip="title: This email will be used for your WebMo; pos:right">
                Email
                <span uk-icon="icon: info; ratio: .9"></span>
              </span>
            </label>
            <div class="uk-form-controls">
                <input v-model.trim="$v.form.email.$model" @input="delayTouch($v.form.email)" :class="{ 'uk-form-danger': $v.form.email.$error }" name="email" class="uk-input" id="email" type="text">
                <div class="uk-form-messages">
                  <div class="uk-form-danger" v-if="!$v.form.email.required && $v.form.email.$dirty">This field is required</div>
                  <div class="uk-form-danger" v-if="!$v.form.email.email && $v.form.email.$dirty">This field must be a valid email</div>
                </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">
              <span uk-tooltip="title: The username is needed to access your WebMo; pos:right">
                Username
                <span uk-icon="icon: info; ratio: .9"></span>
              </span>
            </label>
            <div class="uk-form-controls">
              <input v-model.trim="$v.form.login.$model" @focus="autoFillFormField($v.form.firstname.$model, $event)" @input="delayTouch($v.form.login)" :class="{ 'uk-form-danger': $v.form.login.$error }" name="login" class="uk-input" id="login" type="text">
              <div class="uk-form-messages">
                <div class="uk-form-danger" v-if="!$v.form.login.required && $v.form.login.$dirty">This field is required</div>
                <div class="uk-form-danger" v-if="$v.form.login.required && !$v.form.login.validLogin && $v.form.login.$dirty">
                  The login is not valid.
                  <ul>
                    <li>It must contain between 2 and 255 characters</li>
                    <li>Allowed characters are: digits, English letters, spaces, _ and - </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">
              <span uk-tooltip="title: This will be your WebMo password; pos:right">
                Password
                <span uk-icon="icon: info; ratio: .9"></span>
              </span>
            </label>
            <div class="uk-form-controls">
                <div class="uk-inline uk-display-block">
                  <button tabindex="-1" class="uk-form-icon uk-form-icon-flip" uk-icon="pencil" title="Toggle password visibility" type="button" v-on:click="togglePasswordInput($event)"></button>
                  <input v-model.trim="$v.form.password.$model" @input="delayTouch($v.form.password)" :class="{ 'uk-form-danger': $v.form.password.$error }" type="password" name="password" class="uk-input">
                </div>
                <div class="uk-form-messages">
                  <div class="uk-form-danger" v-if="!$v.form.password.required && $v.form.password.$dirty">This field is required</div>
                  <div class="uk-form-danger" v-if="$v.form.password.required && !$v.form.password.validPassword && $v.form.password.$dirty">
                    The password is not valid. It must contain at least
                    <ul>
                      <li>8 characters</li>
                      <li>one uppercase English letter</li>
                      <li>one lowercase English letter</li>
                      <li>one digit</li>
                    </ul>
                  </div>
                </div>
            </div>
          </div>

          <div class="uk-margin">
            <label class="uk-form-label" for="">How did you come across WebMo?</label>
            <div class="uk-form-controls">
              <textarea id="comment" name="comment" v-model.trim="$v.form.comment.$model" class="uk-textarea" rows="3"></textarea>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-form-controls">
              <div><img id="captachaiamge" :src="captchaSrc"></div>
                <div class="uk-inline uk-display-block">
                  <button tabindex="-1" class="uk-form-icon uk-form-icon-flip" uk-icon="refresh" title="Load a new captcha" type="button" v-on:click="fetchCaptchaToken"></button>
                  <input v-model.trim="$v.form.captchachallenge.$model" :class="{ 'uk-form-danger': $v.form.captchachallenge.$error }"
                   class="uk-input" name="captchachallenge" id="captachachallenge" type="text"
                   autocomplete="off"
                   placeholder="Please enter the text from the image above" v-on:focus="captchaError = false">
                </div>
              <div class="uk-form-messages">
                <div class="uk-form-danger" v-if="!$v.form.captchachallenge.required && $v.form.captchachallenge.$dirty">This field is required</div>
                <div class="uk-form-danger" v-if="$v.form.captchachallenge.required && !$v.form.captchachallenge.validCaptcha && $v.form.captchachallenge.$dirty">Invalid captcha provided. Please try again.</div>
              </div>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-form-controls">
              <label><input id="termsconditions" v-model.trim="$v.form.termsconditions.$model" class="uk-checkbox" type="checkbox"> I agree to the <a target="_blank" rel="noopener" href="https://webmo.info/terms-conditions">General Terms and Conditions</a> and to the  <a target="_blank" rel="noopener" href="https://webmo.info/privacy">Privacy Policy</a>.</label>
              <div class="uk-form-messages">
                <div class="uk-form-danger" v-if="!$v.form.termsconditions.validTerms && $v.form.termsconditions.$dirty">This field needs to be checked.</div>
              </div>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-form-controls">
                <template v-if="isPending">
                  <div uk-spinner></div>
                </template>
                <template v-else-if="isServiceUnavailable">
                  <span uk-icon="icon: warning; ratio: .9"></span> An internal server error occured. If you have not received a confirmation mail, please try again later or contact <a href="mailto:support@webmo.info">our support</a>.
                </template>
                <template v-else>
                  <button id="submit" class="uk-button uk-button-primary">Submit</button>
                </template>
            </div>
          </div>

      </fieldset>
      <input id="captchatoken" name="captchatoken" type="hidden" :value="captchaToken">
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import 'formdata-polyfill';

import { required, email, helpers } from 'vuelidate/lib/validators';
import { upload } from '../js/fakeImageUpload.js';
import { getQueryParameterByName } from '../js/getQueryParameterByName.js';

let validDomain = helpers.regex('validDomain', /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/);
//anubhava's answer https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
let validPassword = helpers.regex('validPassword', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/);
let validLogin = helpers.regex('validLogin', /^[ _\-a-zA-Z0-9]{2,255}$/);
let validImageType = (value) => !helpers.req(value) || ['image/png', 'image/jpeg', 'image/gif'].indexOf(value) !== -1;
let validImageSize = (value) => !helpers.req(value) || value < 50 * 1024;
let validCaptcha = function( value ) { return this.captchaError === false; };
let validTerms = function( value ) { return this.form.termsconditions === true; };

const STATUS_INITIAL = 0, STATUS_PENDING = 1, STATUS_SUCCESS = 2,
      STATUS_FAILED = 3, STATUS_SERVICE_UNAVAILABLE = 4, STATUS_SERVICE_REQUEST_FAILED = 5;
const touchMap = new WeakMap();

export default {
  name: 'OrderForm',

  data() {
    return {
      apiBaseUrl: null,
      types: [],
      languages: [],
      captchaSrc: null,
      captchaToken: null,
      formStatus: 0,
      networkStatus: 0,
      captchaError: false,
      domainValidationNetworkError: null,
      form : {
        type: null,
        language: 'en',
        domain: null,
        logo: {size: 0, mime: null, url: null, name: null},
        firstname: null,
        lastname: null,
        email: null,
        login: null,
        password: null,
        comment: null,
        captchachallenge: null,
        termsconditions: null,
      },
    };
  },

  validations: {
    form: {
      type: { required },
      language: { required },
      firstname: { required },
      lastname: { required },
      domain: {
        required,
        validDomain,
        isUniqueDomain(value){
          if (value === '' && !this.domainValidationNetworkError) return true;
          if (!this.$v.form.domain.validDomain && !this.domainValidationNetworkError) return true;
          return new Promise( (resolve) => {
            let url = this.apiBaseUrl + '/domain/validate/' + value;
            axios({
              url: url,
              method: 'get',
              headers: {'Content-Type': 'application/json'},
            }).then( response => {
                this.domainValidationNetworkError = null;
                resolve(true);
            }).catch(error => {
              if (error.response){
                let status = error.response.status;
                if (status !== 409) {
                  this.domainValidationNetworkError = true;
                  console.error(error);
                } else {
                  this.domainValidationNetworkError = null;
                }
              } else if (error.request) {
                // No response was received
                console.error(error);
                this.networkStatus = STATUS_SERVICE_REQUEST_FAILED;
              } else {
                // Something happened in setting up the request that triggered an Error
                console.error(error);
              }
            });
          });
        },
      },
      logo: {
        mime: { validImageType },
        size: { validImageSize },
      },
      email: { required, email },
      login: { required, validLogin },
      password: { required, validPassword },
      comment: {},
      captchachallenge: { required, validCaptcha },
      termsconditions: { validTerms },
    }
  },

  created () {
    this.apiBaseUrl = process.env.NODE_ENV === 'production' ? 'https://register.webmo.online/' : 'http://localhost:8091/';
    this.apiBaseUrl += 'registrations';
    this.types = ['single', 'multi'];
    this.languages = ['en', 'de', 'es', 'fr'];
    // if a query param ?type has been provided which matches 'this.types', then
    // preselect the form field according to the value given
    if (this.types.some( function (el) { return el === getQueryParameterByName('type'); })){
      this.form.type = getQueryParameterByName('type');
    }
    this.fetchCaptchaToken();
  },

  watch: {
    formStatus () {
      this.$eventHub.$emit('updateFormStatus', this.formStatus);
      if(this.formStatus===STATUS_SUCCESS) {
        this.$eventHub.$emit('updateFormData', this.form);
      }
    },
    networkStatus () {
      this.$eventHub.$emit('updateNetworkStatus', this.networkStatus);
    }
  },

  computed: {
    isPending() {
      return this.formStatus === STATUS_PENDING;
    },
    isServiceUnavailable() {
      return this.networkStatus === STATUS_SERVICE_UNAVAILABLE;
    }
  },

  methods: {
    fetchCaptchaToken() {
      let url = this.apiBaseUrl + '/captcha/acquire';
      axios.get(url).then((response) => {
        this.captchaToken = response.data.token;
        this.captchaSrc = this.apiBaseUrl + '/captcha/image/' + this.captchaToken;
      }).catch( ( error ) => {
        if (error.request) {
          // No response was received
          console.error(error);
          this.networkStatus = STATUS_SERVICE_REQUEST_FAILED;
        }
      });
    },
    handleSubmit(eventObject){
      this.formStatus = STATUS_PENDING;
      let formElement = eventObject.target;
      if(!this.$v.$invalid){
        this.postFormData(formElement);
      } else {
        this.formStatus = STATUS_FAILED;
        this.$v.$touch();
        this.fetchCaptchaToken();
      }
    },
    postFormData(formElement){
      let formData = new FormData(formElement);
      if(this.form.logo.url) formData.append('logoupload', this.form.logo.url);
      let data = {};
      formData.forEach((value, key) => {
        //IE11 adds a space to type and language fields
        value = value.trim !== undefined ? value.trim() : value;
        //it seems FormData converts null to empty string
        value = value === '' ? null : value;
        data[key] = value;
      });
      axios({
        url: this.apiBaseUrl + '/acquire',
        method: 'post',
        data: JSON.stringify(data),
        headers: {'Content-Type': 'application/json'},
      }).then( response => {
        this.formStatus = STATUS_SUCCESS;
      }).catch(error => {
        this.formStatus = STATUS_FAILED;
        if (error.response){
          let msg = error.response.data.message;
          if (msg === 'captcha invalid'){
            this.captchaError = true;
            this.fetchCaptchaToken();
          } else {
            this.networkStatus = STATUS_SERVICE_UNAVAILABLE;
          }
        } else if (error.request) {
          // No response was received
          console.error(error);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error(error);
        }
      });
    },
    togglePasswordInput(eventObject){
      let button = eventObject.currentTarget;
      let input = button.nextSibling;
      if (input.type === 'text') {
        button.setAttribute('uk-icon', 'pencil');
        input.type='password';
      } else {
        button.setAttribute('uk-icon', 'lock');
        input.type='text';
      }
    },
    handleFileChange(eventObject){
      this.form.logo.size = eventObject.target.files[0].size;
      this.form.logo.mime = eventObject.target.files[0].type === '' ? 'invalid' : eventObject.target.files[0].type;
      this.form.logo.url = null;
      this.form.logo.name = null;
      this.fakeImageUpload(eventObject);
    },
    fakeImageUpload(eventObject){
      this.$v.form.logo.$touch(); // we're using a custom validator w/o v-model
      // stop if the logo field is empty or invalid
      if (this.$v.form.logo.$invalid || !this.form.logo.size  || !this.form.logo.mime){
        return false;
      }

      let form = eventObject.currentTarget.form;
      let formData = new FormData(form);
      upload(formData, 'logoupload').then((imgs) => {
        this.form.logo.url = imgs[0].url;
        this.form.logo.name = imgs[0].originalName;
      }).catch((error) => {
        console.error(error);
      });
    },
    resetFileField(eventObject){
      let form = eventObject.currentTarget.form;
      let fileInput = document.querySelectorAll('input[type=\'file\']')[0];
      fileInput.type = '';
      fileInput.type = 'file';
      this.form.logo = {size: 0, mime: null, url: null, name: null};
      fileInput.nextSibling.value = '';
    },
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },
    toLower($v) {
      $v.$model = $v.$model.toLowerCase();
    },
    autoFillFormField(fillContent, eventObject) {
      let formField = eventObject.currentTarget;
      if (formField.value === '') {
        this.form.login = fillContent;
      }
    },
    showNoteOnError(){
      if (this.domainValidationNetworkError) {
        UIkit.notification({message: 'We are sorry. Our domain registration service is currently not available. Please try again in a moment.', status: 'warning', pos:'top-center'});
      }
    },
    getLang(code) {
      let map = {
        'en': 'English',
        'fr': 'French',
        'de': 'German',
        'es': 'Spanish',
      };

      return map[code];
    },
    getType(code) {
      let map = {
        'single': 'Up to 4 projects',
        'multi': 'Up to 20 projects',
      };

      return map[code];
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  div.logo-preview-login {
    width: 400px;

    img {
      max-width: 30%;
    }
  }

  div.logo-preview-sidebar {
    img {
      max-width: 140px;
    }
  }

  input::-ms-clear {
    display: none;
  }

  input::-ms-reveal {
    display: none;
  }

  input[type=radio] {
    margin-right: 0.2rem;
  }

  textarea {
    resize: vertical;
  }

</style>
